export enum DefaultOffsets {
  EXPO = -0.0121776,
  GRACE = -0.010016,
  LIN = 0.0176574,
  MANI = 0.013566, // This is the Cartwheel Mani
  MANNY = -0.01, // this is the UE Manny,
  NONE = 0,
  OPEN_POSE = -0.012908,
  Q = -0.008675,
  UEFN_MANNEQUIN = 0.015, // this is the UEFN Mannequin,
}

const defaultOffset: Record<string, number> = {
  'char-upload-Axel': DefaultOffsets.NONE,
  'char-upload-Expo': DefaultOffsets.EXPO,
  'char-upload-Grace': DefaultOffsets.GRACE,
  'char-upload-Lin': DefaultOffsets.LIN,
  'char-upload-Mani': DefaultOffsets.MANI,
  'char-upload-Manny': DefaultOffsets.MANNY,
  'char-upload-Mark': DefaultOffsets.EXPO,
  'char-upload-Math': DefaultOffsets.EXPO,
  'char-upload-Matt': DefaultOffsets.EXPO,
  'char-upload-Max': DefaultOffsets.EXPO,
  'char-upload-Mo': DefaultOffsets.EXPO,
  'char-upload-Nadia': DefaultOffsets.GRACE,
  'char-upload-Nash': DefaultOffsets.EXPO,
  'char-upload-Nat': DefaultOffsets.GRACE,
  'char-upload-OpenPose': DefaultOffsets.OPEN_POSE,
  'char-upload-Phoebe': DefaultOffsets.GRACE,
  'char-upload-Q': DefaultOffsets.Q,
  'char-upload-Quinn': DefaultOffsets.MANNY,
  'char-upload-Ray': DefaultOffsets.EXPO,
  'char-upload-Shannon': DefaultOffsets.GRACE,
  'char-upload-Subtra': DefaultOffsets.GRACE,
  'char-upload-Tan': DefaultOffsets.EXPO,
  'char-upload-Tess': DefaultOffsets.GRACE,
  'char-upload-Tori': DefaultOffsets.GRACE,
  'char-upload-UEFN_Mannequin': DefaultOffsets.UEFN_MANNEQUIN,
  '': DefaultOffsets.NONE,
};

export default function defaultVerticalOffset(charUploadID: string) {
  return defaultOffset[charUploadID] || 0;
}
